import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'

export const SELLER_SURVEY = gql`
  query sellerSurvey {
    user {
      role
      username
    }
    seller {
      id
      name
      address {
        city
        countryCode
        provinceCode
        neighborhood
      }
      shop {
        reimbursement {
          markup
          operationalBonus
        }
      }
      type
      status
      integration {
        clients {
          name
        }
      }
    }
  }
`
export const SELLER_SURVEY_KEY = 'useSellerSurvey'

export const useSellerSurvey = options =>
  useQuery({
    queryKey: [SELLER_SURVEY_KEY],
    queryFn: () => client.request(SELLER_SURVEY),
    ...options,
  })
